export default __webpack_public_path__ + "static/media/Ram-Ghat-2.3a928710.jpg";